import { DefaultTheme } from 'styled-components';

export const COLORFULL = [
  '#FF7F50',
  '#5F9EA0',
  '#6495ED',
  '#008B8B',
  '#556B2F',
  '#8B008B',
  '#E9967A',
  '#483D8B',
  '#696969',
  '#20B2AA',
  '#66CDAA',
  '#7B68EE',
  '#191970',
  '#BC8F8F',
  '#8B4513',
  '#00FF7F',
  '#008080',
  '#40E0D0',
];

export function getRandomColor() {
  return COLORFULL[Math.floor(Math.random() * COLORFULL.length)];
}

type HexToRgbReturn = { r: number; g: number; b: number };

// https://stackoverflow.com/a/5624139
function hexToRgb(hex: string): HexToRgbReturn {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    return {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    };
  }

  return {
    r: 255,
    g: 255,
    b: 255,
  };
}

// https://stackoverflow.com/a/41491220
export function getFontColor(bgColor: string) {
  var color = hexToRgb(bgColor);
  var uicolors = [color.r / 255, color.g / 255, color.b / 255];
  var c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  return L > 0.179 ? '#000' : '#FFF';
}

export function themeable(theme: DefaultTheme, color?: string): string | null {
  switch (color) {
    case 'primary':
      return theme.colors.primary;
    case 'secondary':
      return theme.colors.secondary;
    case 'success':
      return theme.colors.success;
    case 'warning':
      return theme.colors.warning;
    case 'danger':
      return theme.colors.danger;
    case 'info':
      return theme.colors.info;
    default:
      return null;
  }
}
